// extracted by mini-css-extract-plugin
module.exports = {"main-component":"should_main-component__1JVNg"};